import React from 'react';
import { Box, Container, Flex, Spinner, Text } from '@radix-ui/themes';
import { observer } from 'mobx-react-lite';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';
import NavBar from 'Components/element/NavBar';
import Footer from 'Components/element/Footer';
import { useTgJob } from './tg-job.provider';

const TgJobView = () => {
   const store = useTgJob();
   const navigate = useNavigate();
   const [searchParams] = useSearchParams();
   const token = searchParams.get('token');
   const [invalidToken, setInvalidToken] = React.useState(false);
   const loadingStarted = React.useRef(false);

   React.useEffect(() => {
      if (loadingStarted.current) {
         return;
      }

      loadingStarted.current = true;

      if (!token) {
         navigate('/');
         return;
      }

      store.loadJob(token, {
         onSuccess: (response) => {
            const categorySlug = response.response.category_slug;
            const redirectTo = categorySlug ? `/searchjob/c-${categorySlug}` : '/searchjob';

            navigate(redirectTo);
         },
         onError: (message, status) => {
            if (status === 403) {
               setInvalidToken(true);
               return;
            }

            toast.error(message || 'Telegram job authorization failed');
         },
      });
   }, [navigate, store, token]);

   return (
      <>
         <NavBar />
         <Container size="4" py="9">
            <Box maxHeight="200px" height="200px" width="100%">
               {store.loading && !invalidToken && (
                  <Flex height="100%" align="center" justify="center" aria-busy="true">
                     <Spinner size="3" />
                  </Flex>
               )}

               {invalidToken && (
                  <Flex height="100%" align="center" justify="center">
                     <Text size="5" weight="medium" color="red">
                           Помилка авторизації
                     </Text>
                  </Flex>
               )}
            </Box>
         </Container>
         <Footer />
      </>
   );
};

export const TgJob = observer(TgJobView);
